(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.nowCarousels = {
    attach: function(context, settings) {
      const tabbableElements = 'a:visible, button:visible, input:visible, select:visible, textarea:visible, iframe:visible, area:visible, [contentEditable=true]:visible, [tabindex]:not([tabindex="-1"]):visible';
      let $carousels;

      const prevBtn = '<button class="carousel-button carousel-button--prev" type="button" aria-label="previous"><i class="fas fa-angle-left"></i></button>';
      const nextBtn = '<button class="carousel-button carousel-button--next" type="button" aria-label="next"><i class="fas fa-angle-right"></i></button>';
      const slickOptions = {
        rows: 0,
        infinite: false,
        nextArrow: nextBtn,
        prevArrow: prevBtn,
        centerMode: false,
        variableWidth: false,
        mobileFirst: true,
        dots: false,
        arrows: true,
        autoplay: false,
        speed: 400,
        autoplaySpeed: 14000,
        adaptiveHeight: true,
        cssEase: 'ease',
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false
      };
      // determine the number of items that scroll at once
      const numberOfSlidesScroll = function($slider, $slides) {
        const scrollLg = parseInt($slider.attr('data-slides-scroll-lg'));
        const scrollMd = parseInt($slider.attr('data-slides-scroll-md'));
        const scrollSm = parseInt($slider.attr('data-slides-scroll-sm'));
        let nSlidesScroll = 0;

        if (window.innerWidth > window.breakpoints.lg) {
          if (scrollLg > 0) {
            nSlidesScroll = scrollLg;
          }
          else if (scrollMd > 0) {
            nSlidesScroll = scrollMd;
          }
          else if (scrollSm > 0) {
            nSlidesScroll = scrollSm;
          }
        }
        else if (window.innerWidth > window.breakpoints.md) {
          if (scrollMd > 0) {
            nSlidesScroll = scrollMd;
          }
          else if (scrollSm > 0) {
            nSlidesScroll = scrollSm;
          }
        }
        else if (window.innerWidth > window.breakpoints.sm) {
          if (scrollSm > 0) {
            nSlidesScroll = scrollSm;
          }
        }
        return nSlidesScroll;
      };

      // determine the number of items that can be seen without overflow
      const numberOfSlidesShown = function($slider, $slides) {
        const shownLg = parseInt($slider.attr('data-slides-lg'));
        const shownMd = parseInt($slider.attr('data-slides-md'));
        const shownSm = parseInt($slider.attr('data-slides-sm'));
        let nSlidesShown = 1;

        if (window.innerWidth > window.breakpoints.lg) {
          if (shownLg > 0) {
            nSlidesShown = shownLg;
          }
          else if (shownMd > 0) {
            nSlidesShown = shownMd;
          }
          else if (shownSm > 0) {
            nSlidesShown = shownSm;
          }
          else {
            nSlidesShown = 3;
          }
        }
        else if (window.innerWidth > window.breakpoints.md) {
          if (shownMd > 0) {
            nSlidesShown = shownMd;
          }
          else if (shownSm > 0) {
            nSlidesShown = shownSm;
          }
          else {
            nSlidesShown = 2;
          }
        }
        else if (window.innerWidth > window.breakpoints.sm) {
          if (shownSm > 0) {
            nSlidesShown = shownSm;
          }
          else {
            nSlidesShown = 1;
          }
        }
        return nSlidesShown;
      };

      const carouselControlsTabIndex = function(slick) {
        const $nextArrow = slick.$nextArrow;
        const $prevArrow = slick.$prevArrow;

        if ($nextArrow.attr('aria-disabled') === 'true') {
          $nextArrow.attr('tabindex', -1);
        }
        else {
          $nextArrow.attr('tabindex', '');
        }

        if ($prevArrow.attr('aria-disabled') === 'true') {
          $prevArrow.attr('tabindex', -1);
        }
        else {
          $prevArrow.attr('tabindex', '');
        }
      };

      const hideOffscreenTabbables = function() {
        jQuery('.slick-slide').find(tabbableElements).attr('tabindex', -1);
        jQuery('.slick-slide.slick-active').find(tabbableElements).attr('tabindex', 0);
      };

      const carouselOnInit = function(event, slick) {
        // Center buttons relative to the slides
        // Ignoring any elements (like titles) marked data-slick-ignore-height
        if (slick.$slides) {
          const $slide = slick.$slides.first();
          const $nextArrow = slick.$nextArrow;
          const $prevArrow = slick.$prevArrow;
          var h = $slide.height();
          $slide.find('[data-slick-ignore-height]').each(function(i) {
            const $item = jQuery(this);
            h = h - $item.outerHeight(true);
          });
          let t = (h - $nextArrow.height()) / 2;
          $nextArrow.css('top', t + 'px');
          $prevArrow.css('top', t + 'px');

          carouselControlsTabIndex(slick);
          hideOffscreenTabbables();
        }
        else {
          setTimeout(function() {
            carouselOnInit(event, slick);
          }, 200);
        }
      };

      const carouselAfterChange = function(event, slick, currentSlide, nextSlide) {
        if (window.bLazy) {
          window.bLazy.revalidate();
        }
        carouselControlsTabIndex(slick);
        hideOffscreenTabbables();
        // focus first slide
        const $current = slick.$slides[currentSlide];
        $current.focus();
      };

      const carouselInit = function($carousel) {

        // un-slick before we re-slick
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
        // Only initialize slick if the carousel multiple pages of slides
        // trying to init otherwise causes the window to crash.

        // set contextual options
        let n = numberOfSlidesShown($carousel, $carousel.children());
        slickOptions.slidesToScroll = n;
        slickOptions.slidesToShow = n;

        let o = numberOfSlidesScroll($carousel, $carousel.children());
        if (o < 0) {
          slickOptions.slidesToScroll = o;
        }

        $carousel.on('init', carouselOnInit).on('afterChange', carouselAfterChange).slick(slickOptions);
      };

      const carouselsReady = function() {
        $carousels = jQuery('.carousel');
        if ($carousels.length > 0) {
          $carousels.each((i, carousel) => {
            const $carousel = jQuery(carousel);
            carouselInit($carousel);
          });
        }
      };

      window.eventQueue.addReady(carouselsReady, 'carousels');
      window.eventQueue.addResize(carouselsReady);

      // Add an event listener for the popstate event
      window.addEventListener('popstate', function(event) {
        // Check if the event state exists
        if (event.state) {
          console.log('State:', event.state);
        }
      });

      // Example of pushing a state to the history
      function pushState() {
        const state = { back: 'back button pressed' };
        history.pushState(state, 'Previous Page', '');
      }

      // Call this function at some point to create history entries
      pushState();
    }
  };
})(jQuery, Drupal);
